module.exports = __webpack_public_path__ + "static/media/roundaboutCCW90.d723ddf2.svg";